import React from 'react';
import { TFunction } from 'i18next';
import { DataTableMeta, LimitedContent } from '@otp/ui';
import { Tag } from 'src/graphql/generated/graphql';
import { ActionsColumn } from './columns/actions';
import { PermissionListItem } from 'src/components/permissions/list/types';
import { TagsField } from 'src/components/common/table/columns/tags';
import { IsActiveColumn } from 'src/components/common/table/columns/is-active';
import { AssignedByColumn } from './columns/assigned-by';

export const getTableConfig = (
  permissions: PermissionListItem[],
  {
    t,
    onActionFinished,
    disabledFields,
  }: {
    t: TFunction;
    onActionFinished?: (action: any) => void;
    disabledFields?: Array<string>;
  },
) => [
  ...(disabledFields?.includes('isDisabled')
    ? []
    : [
        {
          name: 'isDisabled',
          label: t('common.status.label'),
          options: {
            customBodyRender: (isDisabled: boolean, column: DataTableMeta) => {
              const permission = permissions[column.rowIndex];
              const { isDeleted } = permission;

              return (
                <IsActiveColumn
                  isDisabled={isDisabled}
                  isDeleted={!!isDeleted}
                />
              );
            },
          },
        },
      ]),
  {
    name: 'name',
    label: t('common.name'),
  },
  {
    name: 'description',
    label: t('common.description'),
    options: {
      customBodyRender: (value: string) => {
        return (
          <LimitedContent maxRows={2}>
            <div dangerouslySetInnerHTML={{ __html: value }} />
          </LimitedContent>
        );
      },
    },
  },
  ...(disabledFields?.includes('tags')
    ? []
    : [
        {
          name: 'tags',
          label: t('common.tags'),
          options: {
            customBodyRender: (tags: Tag[]) => {
              return <TagsField tags={tags} />;
            },
          },
        },
      ]),
  ...(disabledFields?.includes('actions')
    ? []
    : [
        {
          name: 'actions',
          label: t('common.actions'),
          options: {
            customBodyRender: (_: any, column: DataTableMeta) => {
              const permission = permissions[column.rowIndex];

              return (
                <ActionsColumn
                  permission={permission}
                  onActionFinished={onActionFinished}
                />
              );
            },
          },
        },
      ]),
  ...(disabledFields?.includes('explain')
    ? []
    : [
        {
          name: 'actions',
          label: t('common.explain'),
          options: {
            customBodyRender: (_: any, column: DataTableMeta) => {
              const assignedBy = permissions[column.rowIndex].assignedBy;

              return <AssignedByColumn assignedBy={assignedBy || []} />;
            },
          },
        },
      ]),
];
